module.exports = __webpack_public_path__ + "static/megaphone-64fe6bfecfb63e8419014b56753cf702.mp4";